import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { CounterPartyOptions } from 'enums/onboarding/crm';
import { FormSelectProps, SelectOption } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const CounterPartySelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(CounterPartyOptions).map((key) => ({
        id: key,
        label: t(`intake_form.counter_party_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default CounterPartySelect;
